module.exports = __webpack_public_path__ + "img/Banner-Home.dad0c043.jpg";